import React, { createContext, useContext, useState } from 'react';
import ConfirmationModal from './components/ConfirmationModal';

const ModalContext = createContext();

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    open: false,
    type: 'confirm',
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    confirmText: 'OK',
    cancelText: 'Abbrechen'
  });

  const showConfirm = ({
    title = 'Bestätigung',
    message,
    confirmText = 'OK',
    cancelText = 'Abbrechen'
  }) => {
    return new Promise((resolve) => {
      setModal({
        open: true,
        type: 'confirm',
        title,
        message,
        confirmText,
        cancelText,
        onConfirm: () => {
          setModal(prev => ({ ...prev, open: false }));
          resolve(true);
        },
        onCancel: () => {
          setModal(prev => ({ ...prev, open: false }));
          resolve(false);
        }
      });
    });
  };

  const showAlert = ({
    title = 'Information',
    message,
    confirmText = 'OK'
  }) => {
    return new Promise((resolve) => {
      setModal({
        open: true,
        type: 'alert',
        title,
        message,
        confirmText,
        onConfirm: () => {
          setModal(prev => ({ ...prev, open: false }));
          resolve();
        },
        onCancel: () => {
          setModal(prev => ({ ...prev, open: false }));
          resolve();
        }
      });
    });
  };

  const closeModal = () => {
    setModal(prev => ({ ...prev, open: false }));
  };

  const contextValue = {
    showConfirm,
    showAlert,
    closeModal
  };

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
      <ConfirmationModal
        open={modal.open}
        type={modal.type}
        title={modal.title}
        message={modal.message}
        confirmText={modal.confirmText}
        cancelText={modal.cancelText}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
      />
    </ModalContext.Provider>
  );
};